import { render, staticRenderFns } from "./BackhaulControls.vue?vue&type=template&id=37f9f36b"
import script from "./BackhaulControls.vue?vue&type=script&lang=js"
export * from "./BackhaulControls.vue?vue&type=script&lang=js"
import style0 from "./BackhaulControls.vue?vue&type=style&index=0&id=37f9f36b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports